import ListeningQueue from './ListeningQueue';

export default ListeningQueue;
